import { EventEmitter } from '@angular/core';
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
var LearningPathIntroductionComponent = (function () {
    function LearningPathIntroductionComponent(apiService, commonService) {
        this.apiService = apiService;
        this.commonService = commonService;
        this.onCloseLearningPathIntroduction = new EventEmitter();
        this.introductionSubTitle = ""; //副标题
        this.learningPathName = ""; //learningPathName
        this.longPicArr = [];
        this.isClosePage = false; //是否关闭页面
        this.isShowCloseBtn = true; //是否显示关闭按钮
    }
    LearningPathIntroductionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.introductionSubTitle = this.setIntroductionSubTitle(this.learningPathMetaId);
        this.learningPathName = this.commonService.getCourseNameWithLearningPathMetaId(Number(this.learningPathMetaId));
        this.commonService.getOnceIno(this.onceValue).then(function (result) {
            _this.isShowCloseBtn = result === 1 ? false : true;
        });
        if (this.learningPathMetaId === 315 || this.learningPathMetaId === 325 || this.learningPathMetaId == 208 || this.learningPathMetaId == 209 || this.learningPathMetaId == 307 || this.learningPathMetaId == 210) {
            this.longPicArr = [{ 'index': 1, 'content': '你将收获:' }, { 'index': 2, 'content': '你的能力任务:' }];
        }
        else {
            this.longPicArr = [{ 'index': 1, 'content': '你将收获:' }, { 'index': 2, 'content': '你的实战任务:' }];
        }
    };
    // 0DNA 1辅导 2团队 11授权 12沟通 13组织 14协作 15影响力 16决策 18启程 20变革 22影响力增强 24MAX 26TS 28冲突 30影响力专业
    LearningPathIntroductionComponent.prototype.setIntroductionSubTitle = function (learningPathMetaId) {
        return {
            1: '下属表现的好坏，反映了领导者的能力。',
            605: '下属表现的好坏，反映了领导者的能力。',
            2: '领导者必须要知道的成功五要素。',
            11: '摆脱平庸，向上提升。',
            12: '沟通无处不在，学会 “无招胜有招” 的沟通心法。',
            13: '优雅惬意地应对日常。',
            14: '击破 “本位主义” ，找到双赢局面。',
            16: '遇事不乱，多谋善断。',
            308: '遇事不乱，多谋善断。',
            318: '遇事不乱，多谋善断。',
            311: '炼就你的火眼金睛，面试中辨识“对的人”。',
            20: '让团队拥抱变化，加速变革。',
            309: '让团队拥抱变化，加速变革。',
            24: '每个人的绩效都与公司愿景息息相关。',
            26: '炼就你的火眼金睛，面试中辨识“对的人”。',
            28: '调整 “对立” 心态，改变冲突行为。',
            201: '炼就你的火眼金睛，面试中辨识“对的人”。',
            301: '炼就你的火眼金睛，面试中辨识“对的人”。',
            202: '沟通无处不在，学会 “无招胜有招” 的沟通心法。',
            302: '沟通无处不在，学会 “无招胜有招” 的沟通心法。',
            312: '沟通无处不在，学会 “无招胜有招” 的沟通心法。',
            402: '沟通无处不在，学会 “无招胜有招” 的沟通心法。',
            403: '摆脱平庸，向上提升。',
            205: '下属表现的好坏，往往反映领导者的能力。',
            305: '下属表现的好坏，往往反映领导者的能力。',
            315: '下属表现的好坏，往往反映领导者的能力。',
            325: '下属表现的好坏，往往反映领导者的能力。',
            335: '下属表现的好坏，往往反映领导者的能力。',
            405: '下属表现的好坏，往往反映领导者的能力。',
            406: '每个人的绩效都与公司愿景息息相关。',
            606: '每个人的绩效都与公司愿景息息相关。',
            208: '执行力犹如一对坚实的翅膀，将组织的战略目标成功落地。',
            209: '识别员工的激励驱动因子，将激励与留才贯穿到日常管理的点点滴滴，从而提升员工的敬业度与贡献度。',
            210: '在无法频繁见面的情况下，如何运用数字化工具和管理技巧满足团队成员的需求，带领虚拟团队有效取得成果？',
            211: '无应用，不发展；无衡量，不成事。',
            212: '全面开启，步步为营，成为推动创新落地的“孵化者”。',
            304: '击破 “本位主义” ，找到双赢局面。',
            303: '摆脱平庸，向上提升。',
            204: '一群人为了共同的目标而奋斗，通过相互合作达成目标。'
        }[Number(learningPathMetaId)] || '获得他人承诺，以推动事情发生。';
    };
    //关闭介绍页
    LearningPathIntroductionComponent.prototype.closeLearningPathIntroduction = function () {
        var _this = this;
        this.isClosePage = true;
        this.commonService.setOnceIno(this.onceValue).subscribe();
        // if(this.isShowCloseBtn){
        //   this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'退出能力介绍页','userId':localStorage.getItem('userId')}).then();
        // }
        setTimeout(function () {
            _this.onCloseLearningPathIntroduction.emit();
        }, 300);
    };
    LearningPathIntroductionComponent.prototype.closeLearningPathIntroductionWithDetail = function () {
        if (this.isShowCloseBtn) {
            return;
        }
        else {
            this.closeLearningPathIntroduction();
        }
    };
    return LearningPathIntroductionComponent;
}());
export { LearningPathIntroductionComponent };



// WEBPACK FOOTER //
// ./src/app/learning-path-introduction/learning-path-introduction.component.ts.pre-build-optimizer.js